export const FETCH_ALL = "FETCH_ALL";
export const ADD_NEW = "ADD_NEW";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const GET_INVOICE = "GET_INVOICE";
export const GET_ADD_NEW_INVOICE = "GET_ADD_NEW_INVOICE";
export const FETCH_INVOICE_BY_USER = "FETCH_INVOICE_BY_USER";
export const FETCH_INVOICE_BY_RENTALID = "FETCH_INVOICE_BY_RENTALID";
export const ALL_CLIENTS = "ALL_CLIENTS";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT";
export const FETCH_CLIENTS_BY_USER = "FETCH_CLIENTS_BY_USER";
export const FETCH_CLIENTS_BY_SEARCH_QUERY = "FETCH_CLIENTS_BY_SEARCH_QUERY";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const FETCH_CLIENT = "FETCH_CLIENT";

export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const CREATE_PROFILE = "CREATE_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const DELETE_PROFILE = "DELETE_PROFILE";
export const FETCH_PROFILES = "FETCH_PROFILES";
export const FETCH_PROFILE = "FETCH_PROFILE";
export const FETCH_PROFILE_BY_USER = "FETCH_PROFILE_USER";
export const FETCH_PROFILES_BY_USER = "FETCH_PROFILES_BY_USER";

export const UPLOAD_FILE = "UPLOAD_FILE";
export const FETCH_FILE = "FETCH_FILE";
export const FETCH_FILES_BY_USER = "FETCH_FILES_BY_USER";
export const FETCH_INVOICE_NUMBER = "FETCH_INVOICE_NUMBER";

export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const FETCH_CATEGORY = "FETCH_CATEGORY";
export const FETCH_CATEGORIES_BY_USER = "FETCH_CATEGORIES_BY_USER";

export const CREATE_ITEM = "CREATE_ITEM";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";
export const FETCH_ITEM = "FETCH_ITEM";
export const FETCH_ITEMS_BY_USER = "FETCH_ITEMS_BY_USER";
export const ITEMS_LAST_MODIFIED_BY_USER = "ITEMS_LAST_MODIFIED_BY_USER";
export const FIND_ITEM_BY_BARCODE = "FIND_ITEM_BY_BARCODE";
export const ITEM_CATEGORY = "ITEM_CATEGORY";
export const ADD_NEW_RECEIPT = "ADD_NEW_RECEIPT";

export const CREATE_COMPANY = "CREATE_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";
export const FETCH_COMPANY = "FETCH_COMPANY";
export const FETCH_COMPANIES = "FETCH_COMPANIES";
export const COMPANIES_LAST_MODIFIED = "COMPANIES_LAST_MODIFIED";
export const CHECK_DOMAIN = "CHECK_DOMAIN";

export const CREATE_USER_GROUP = "CREATE_USER_GROUP";
export const UPDATE_USER_GROUP = "UPDATE_USER_GROUP";
export const DELETE_USER_GROUP = "DELETE_USER_GROUP";
export const FETCH_USER_GROUP = "FETCH_USER_GROUP";
export const FETCH_USER_GROUPS = "FETCH_USER_GROUPS";
export const FETCH_ROLES = "FETCH_ROLES";

export const CREATE_USER = "CREATE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const FETCH_USER = "FETCH_USER";
export const FETCH_USERS = "FETCH_USERS";
export const DOWNLOAD_PDF_INVOICE = "DOWNLOAD_PDF_INVOICE";
export const EMAIL_INVOICE = "EMAIL_INVOICE";
export const paymentMethods = [
  {
    title: "Credit",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  { title: "Cash", paidAmount: 0, note: "", date: new Date().toLocaleString() },
  {
    title: "Transfer",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "Check",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "PayPal",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "Others",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
];

export const ADD_UNIT = "CREATE_UNIT";
export const UPDATE_UNIT = "UPDATE_UNIT";
export const DELETE_UNIT = "DELETE_UNIT";
export const FETCH_UNITS = "FETCH_UNITS";
export const FETCH_UNIT = "FETCH_UNIT";

export const FETCH_RENTALS = "FETCH_RENTALS";
export const FETCH_UNPAID_RENTALS = "FETCH_UNPAID_RENTALS";
export const FETCH_RENTAL = "FETCH_RENTAL";
export const ADD_RENTAL = "ADD_RENTAL";
export const UPDATE_RENTAL = "UPDATE_RENTAL";
export const DELETE_RENTAL = "DELETE_RENTAL";

export const ADD_BUILDING = "CREATE_BUILDING";
export const UPDATE_BUILDING = "UPDATE_BUILDING";
export const DELETE_BUILDING = "DELETE_BUILDING";
export const FETCH_BUILDINGS = "FETCH_BUILDINGS";
export const FETCH_BUILDING = "FETCH_BUILDING";

export const ADD_TRANSACTION = "ADD_TRANSACTION";
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";
export const DELETE_TRANSACTION = "DELETE_TRANSACTION";
export const FETCH_TRANSACTIONS = "FETCH_TRANSACTIONS";
export const FETCH_TRANSACTION = "FETCH_TRANSACTION";

export const ADD_ACCOUNT = "ADD_ACCOUNT";
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const FETCH_ACCOUNTS = "FETCH_ACCOUNTS";
export const FETCH_ACCOUNT = "FETCH_ACCOUNT";

// Profit Centers Constants
export const FETCH_PROFIT_CENTERS = "FETCH_PROFIT_CENTERS";
export const FETCH_PROFIT_CENTER = "FETCH_PROFIT_CENTER";
export const ADD_PROFIT_CENTER = "ADD_PROFIT_CENTER";
export const UPDATE_PROFIT_CENTER = "UPDATE_PROFIT_CENTER";
export const DELETE_PROFIT_CENTER = "DELETE_PROFIT_CENTER";
export const PROFIT_CENTERS_ERROR = "PROFIT_CENTERS_ERROR";

export const ADD_LETTER = "ADD_LETTER";
export const UPDATE_LETTER = "UPDATE_LETTER";
export const DELETE_LETTER = "DELETE_LETTER";
export const FETCH_LETTERS = "FETCH_LETTERS";
export const FETCH_LETTER = "FETCH_LETTER";
export const CLEAR_CURRENT_LETTER = "CLEAR_CURRENT_LETTER";

export const SEED_ACCOUNT = "SEED_ACCOUNT";
export const FETCH_TRIAL_BALANCE = "FETCH_TRIAL_BALANCE";
export const FETCH_BALANCE_SHEET = "FETCH_BALANCE_SHEET";

export const ADD_PURCHASE_INVOICE = "ADD_PURCHASE_INVOICE";
export const UPDATE_PURCHASE_INVOICE = "UPDATE_PURCHASE_INVOICE";
export const DELETE_PURCHASE_INVOICE = "DELETE_PURCHASE_INVOICE";
export const FETCH_PURCHASE_INVOICES = "FETCH_PURCHASE_INVOICES";
export const FETCH_PURCHASE_INVOICE = "FETCH_PURCHASE_INVOICE";
export const FETCH_LAST_PURCHASE_NUMBER = "FETCH_LAST_PURCHASE_NUMBER";
export const DOWNLOAD_PURCHASE_PDF_INVOICE = "DOWNLOAD_PURCHASE_PDF_INVOICE";
export const EMAIL_PURCHASE_INVOICE = "EMAIL_PURCHASE_INVOICE";
export const CLEAR_CURRENT_PURCHASE_INVOICE = "CLEAR_CURRENT_PURCHASE_INVOICE";

export const CREATE_PAYROLL = "CREATE_PAYROLL";
export const FETCH_PAYROLLS = "FETCH_PAYROLLS";

export const RECORD_ATTENDANCE = "RECORD_ATTENDANCE";
export const FETCH_ATTENDANCE_RECORDS = "FETCH_ATTENDANCE_RECORDS";

// SMS Settings
export const FETCH_SMS_SETTINGS = "FETCH_SMS_SETTINGS";
export const UPDATE_SMS_SETTINGS = "UPDATE_SMS_SETTINGS";

// Barcode Settings Constants
export const FETCH_BARCODE_SETTINGS = "FETCH_BARCODE_SETTINGS";
export const FETCH_BARCODE_SETTING = "FETCH_BARCODE_SETTING";
export const ADD_BARCODE_SETTING = "ADD_BARCODE_SETTING";
export const UPDATE_BARCODE_SETTING = "UPDATE_BARCODE_SETTING";
export const DELETE_BARCODE_SETTING = "DELETE_BARCODE_SETTING";
export const CLEAR_CURRENT_BARCODE_SETTING = "CLEAR_CURRENT_BARCODE_SETTING";

// Tax Settings Types
export const FETCH_All_TAX_SETTINGS = "FETCH_All_TAX_SETTINGS";
export const FETCH_TAX_SETTINGS_BY_ID = "FETCH_TAX_SETTINGS_BY_ID";
export const CREATE_TAX_SETTINGS = "CREATE_TAX_SETTINGS";
export const UPDATE_TAX_SETTINGS = "UPDATE_TAX_SETTINGS";
export const DELETE_TAX_SETTINGS = "DELETE_TAX_SETTINGS";

//Costcenters
export const FETCH_ALL_CONST_CENTERS = "FETCH_ALL_CONST_CENTERS";
export const ADD_CONST_CENTERS = "ADD_CONST_CENTERS";
export const FETCH_COST_CENTERS_BY_ID = "FETCH_COST_CENTERS_BY_ID";
export const UPDATE_CONST_CENTERS = "UPDATE_CONST_CENTERS";
export const DELETE_CONST_CENTERS = "DELETE_CONST_CENTERS";
export const FETCH_ALL_CONST_CENTERS_COMPANY =
  "FETCH_ALL_CONST_CENTERS_COMPANY";

// projects
export const FETCH_PROJECTS = "FETCH_PROJECTS";
export const FETCH_PROJECT = "FETCH_PROJECT";
export const ADD_PROJECT = "ADD_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const PROJECTS_ERROR = "PROJECTS_ERROR";

// Assets Types
export const FETCH_ASSETS = "FETCH_ASSETS";
export const FETCH_ASSET = "FETCH_ASSET";
export const ADD_ASSET = "ADD_ASSET";
export const UPDATE_ASSET = "UPDATE_ASSET";
export const DELETE_ASSET = "DELETE_ASSET";

// SMS Providers Types
export const FETCH_SMS_PROVIDERS = "FETCH_SMS_PROVIDERS";
export const FETCH_SMS_PROVIDER = "FETCH_SMS_PROVIDER";
export const ADD_SMS_PROVIDER = "ADD_SMS_PROVIDER";
export const UPDATE_SMS_PROVIDER = "UPDATE_SMS_PROVIDER";
export const SMS_PROVIDERS_ERROR = "SMS_PROVIDERS_ERROR";
export const DELETE_SMS_PROVIDER = "DELETE_SMS_PROVIDER";

// Notification Constants
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const FETCH_NOTIFICATION = "FETCH_NOTIFICATION";

// Coupons
export const FETCH_COUPONS = "FETCH_COUPONS";
export const FETCH_COUPON = "FETCH_COUPON";
export const FETCH_COUPON_BY_CODE = "FETCH_COUPON_BY_CODE";
export const CREATE_COUPON = "CREATE_COUPON";
export const UPDATE_COUPON = "UPDATE_COUPON";
export const DELETE_COUPON = "DELETE_COUPON";
export const COUPON_ERROR = "COUPON_ERROR";

// Vouchers
export const CREATE_VOUCHERS = "CREATE_VOUCHERS";
export const FETCH_VOUCHERS = "FETCH_VOUCHERS";
export const USE_VOUCHERS = "USE_VOUCHERS";
export const DELETE_VOUCHERS = "DELETE_VOUCHERS";
export const ERROR_VOUCHERS = "ERROR_VOUCHERS";

// Communication
export const WHATSAPP_LOGIN = "WHATSAPP_LOGIN";
export const WHATSAPP_LOGIN_ERROR = "WHATSAPP_LOGIN_ERROR";
export const SET_SOCKET_CONNECTED = "SET_SOCKET_CONNECTED";
export const SET_SOCKET_DATA = "SET_SOCKET_DATA";
export const SET_SOCKET_ERROR = "SET_SOCKET_ERROR";
export const SET_SOCKET_INSTANCE = "SET_SOCKET_INSTANCE";
export const CONNECT_WHATSAPP = "CONNECT_WHATSAPP";
export const CONNECT_WHATSAPP_ERROR = "CONNECT_WHATSAPP_ERROR";

// Email
export const CREATE_SMTP_CONFIG = "CREATE_SMTP_CONFIG";
export const CREATE_SMTP_TEST = "CREATE_SMTP_TEST";
export const SMTP_ERROR = "SMTP_ERROR";

export const WHATSAPP_LOGOUT = "WHATSAPP_LOGOUT";
export const WHATSAPP_LOGOUT_ERROR = "WHATSAPP_LOGOUT_ERROR";

// ProductPackages
export const CREATE_PRODUCT_PACKAGE = "CREATE_PRODUCT_PACKAGE";
export const FETCH_PRODUCT_PACKAGES = "FETCH_PRODUCT_PACKAGES";
export const UPDATE_PRODUCT_PACKAGE = "UPDATE_PRODUCT_PACKAGE";
export const PRODUCT_PACKAGE_ERROR = "PRODUCT_PACKAGE_ERROR";
export const FETCH_PRODUCT_PACKAGE = "FETCH_PRODUCT_PACKAGE";
export const DELETE_PRODUCT_PACKAGE = "DELETE_PRODUCT_PACKAGE";
export const FETCH_PRODUCT_PACKAGES_BY_LANG = "FETCH_PRODUCT_PACKAGES_BY_LANG";

// Features
export const FETCH_FEATURES = "FETCH_FEATURES";
export const FETCH_FEATURE_BY_LANG = "FETCH_FEATURE_BY_LANG";
export const CREATE_FEATURE = "CREATE_FEATURE";
export const UPDATE_FEATURE = "UPDATE_FEATURE";
export const DELETE_FEATURE = "DELETE_FEATURE";
export const ERROR_FEATURE = "ERROR_FEATURE";

// Translation
export const TRANSALTE = "TRANSALTE";
export const ERROR_TRANSALTE = "ERROR_TRANSALTE";

// Account Settings
export const FETCH_ACCOUNT_SETTINGS = "FETCH_ACCOUNT_SETTINGS";
export const CREATE_ACCOUNT_SETTINGS = "CREATE_ACCOUNT_SETTINGS";
export const UPDATE_ACCOUNT_SETTINGS = "UPDATE_ACCOUNT_SETTINGS";
export const ACCOUNT_SETTINGS_ERROR = "ACCOUNT_SETTINGS_ERROR";

// Properties
export const FETCH_PROPERTIES = "FETCH_PROPERTIES";
export const FETCH_PROPERTY = "FETCH_PROPERTY";
export const CREATE_PROPERTY = "CREATE_PROPERTY";
export const UPDATE_PROPERTY = "UPDATE_PROPERTY";
export const DELETE_PROPERTY = "DELETE_PROPERTY";
export const ADD_ATTACHMENT = "ADD_ATTACHMENT";
export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";
export const UPLOAD_ATTACHMENTS = "UPLOAD_ATTACHMENTS";
export const UPLOAD_MULTIPLE_ATTACHMENTS = "UPLOAD_MULTIPLE_ATTACHMENTS";
export const ERROR_PROPERTY = "ERROR_PROPERTY";
export const ERROR_DELETEING_ATTACHMENT = "ERROR_DELETEING_ATTACHMENT";
export const ERROR_UPLOADING_ATTACHMENTS = "ERROR_UPLOADING_ATTACHMENTS";

export const SEARCH_PROPERTIES = "SEARCH_PROPERTIES";
export const PROPERTY_ERROR = "PROPERTY_ERROR";

// Messaging constants
export const FETCH_CONVERSATIONS = "FETCH_CONVERSATIONS";
export const FETCH_CONVERSATION = "FETCH_CONVERSATION";
export const CREATE_CONVERSATION = "CREATE_CONVERSATION";
export const UPDATE_CONVERSATION = "UPDATE_CONVERSATION";
export const DELETE_CONVERSATION = "DELETE_CONVERSATION";
export const FETCH_MESSAGES = "FETCH_MESSAGES";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const ADD_PARTICIPANT = "ADD_PARTICIPANT";
export const REMOVE_PARTICIPANT = "REMOVE_PARTICIPANT";
export const FETCH_UNREAD_COUNT = "FETCH_UNREAD_COUNT";
export const MARK_AS_READ = "MARK_AS_READ";
export const UPLOAD_MESSAGE_ATTACHMENT = "UPLOAD_MESSAGE_ATTACHMENT";
export const DELETE_MESSAGE_ATTACHMENT = "DELETE_MESSAGE_ATTACHMENT";
export const MESSAGING_ERROR = "MESSAGING_ERROR";
export const MESSAGING_LOADING = "MESSAGING_LOADING";

// Clinic Management Constants
export const FETCH_DOCTORS = "FETCH_DOCTORS";
export const FETCH_DOCTOR = "FETCH_DOCTOR";
export const CREATE_DOCTOR = "CREATE_DOCTOR";
export const UPDATE_DOCTOR = "UPDATE_DOCTOR";
export const DELETE_DOCTOR = "DELETE_DOCTOR";

export const FETCH_PATIENTS = "FETCH_PATIENTS";
export const FETCH_PATIENT = "FETCH_PATIENT";
export const CREATE_PATIENT = "CREATE_PATIENT";
export const UPDATE_PATIENT = "UPDATE_PATIENT";
export const DELETE_PATIENT = "DELETE_PATIENT";

export const FETCH_APPOINTMENTS = "FETCH_APPOINTMENTS";
export const FETCH_APPOINTMENT = "FETCH_APPOINTMENT";
export const CREATE_APPOINTMENT = "CREATE_APPOINTMENT";
export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";

export const FETCH_LAB_RESULTS = "FETCH_LAB_RESULTS";
export const FETCH_LAB_RESULT = "FETCH_LAB_RESULT";
export const CREATE_LAB_RESULT = "CREATE_LAB_RESULT";
export const UPDATE_LAB_RESULT = "UPDATE_LAB_RESULT";
export const DELETE_LAB_RESULT = "DELETE_LAB_RESULT";

export const FETCH_LAB_TESTS = "FETCH_LAB_TESTS";
export const FETCH_LAB_TEST = "FETCH_LAB_TEST";
export const CREATE_LAB_TEST = "CREATE_LAB_TEST";
export const UPDATE_LAB_TEST = "UPDATE_LAB_TEST";
export const DELETE_LAB_TEST = "DELETE_LAB_TEST";
export const CLEAR_LAB_TEST = "CLEAR_LAB_TEST";

export const FETCH_MEDICAL_RECORDS = "FETCH_MEDICAL_RECORDS";
export const FETCH_MEDICAL_RECORD = "FETCH_MEDICAL_RECORD";
export const CREATE_MEDICAL_RECORD = "CREATE_MEDICAL_RECORD";
export const UPDATE_MEDICAL_RECORD = "UPDATE_MEDICAL_RECORD";
export const DELETE_MEDICAL_RECORD = "DELETE_MEDICAL_RECORD";

export const FETCH_MEDICAL_SERVICES = "FETCH_MEDICAL_SERVICES";
export const FETCH_MEDICAL_SERVICE = "FETCH_MEDICAL_SERVICE";
export const CREATE_MEDICAL_SERVICE = "CREATE_MEDICAL_SERVICE";
export const UPDATE_MEDICAL_SERVICE = "UPDATE_MEDICAL_SERVICE";
export const DELETE_MEDICAL_SERVICE = "DELETE_MEDICAL_SERVICE";

export const FETCH_MEDICATIONS = "FETCH_MEDICATIONS";
export const FETCH_MEDICATION = "FETCH_MEDICATION";
export const CREATE_MEDICATION = "CREATE_MEDICATION";
export const UPDATE_MEDICATION = "UPDATE_MEDICATION";
export const DELETE_MEDICATION = "DELETE_MEDICATION";
export const CLEAR_MEDICATION = "CLEAR_MEDICATION";

export const FETCH_PRESCRIPTIONS = "FETCH_PRESCRIPTIONS";
export const FETCH_PRESCRIPTION = "FETCH_PRESCRIPTION";
export const CREATE_PRESCRIPTION = "CREATE_PRESCRIPTION";
export const UPDATE_PRESCRIPTION = "UPDATE_PRESCRIPTION";
export const DELETE_PRESCRIPTION = "DELETE_PRESCRIPTION";
export const CLEAR_PRESCRIPTION = "CLEAR_PRESCRIPTION";
